import axios, { type AxiosInstance } from 'axios';
import toast from 'react-hot-toast';
import { env } from '@/config/env';

/**
 * Single axios instance for the whole app — every service imports this,
 * never axios directly. Auth (CSRF, sessions, refresh-token) is intentionally
 * left out for now; add it back into the interceptors here when it's needed.
 */
const api: AxiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

// ── Response interceptor — surface network-level failures as a toast ──────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      toast.error(
        error.code === 'ECONNABORTED'
          ? 'The request timed out. Please try again.'
          : 'Unable to connect to the server. Please check your network and try again.',
        { id: 'network-error' },
      );
    }
    return Promise.reject(error);
  },
);

export default api;
